export type PasswordValidationErrorKey =
  | 'passwordMinLength'
  | 'passwordComplexity'
  | 'passwordTooEasy'
  | 'passwordMatchesPhone';

const MIN_PASSWORD_LENGTH = 8;

const normalizePhoneNumber = (value?: string | null) => {
  if (!value || value.includes('@')) {
    return '';
  }

  return value.replace(/\D/g, '');
};

export const getPasswordValidationErrorKey = (
  password: string,
  registeredPhone?: string | null,
): PasswordValidationErrorKey | null => {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return 'passwordMinLength';
  }

  const normalizedPhone = normalizePhoneNumber(registeredPhone);
  if (normalizedPhone && password === normalizedPhone) {
    return 'passwordMatchesPhone';
  }

  if (password === '123456') {
    return 'passwordTooEasy';
  }

  if (!/[A-Z]/.test(password) || !/[a-z]/.test(password) || !/\d/.test(password) || !/[^a-zA-Z0-9]/.test(password)) {
    return 'passwordComplexity';
  }

  return null;
};